import { required, requiredIf } from "vuelidate/lib/validators";

const step5 = ["form.q_5_1", "form.q_5_1a", "form.q_5_1b", "form.q_5_1c"];

const require51 = function(m) {
  return this.form.q_5_1 === true;
};

const step5Validations = {
  q_5_1: { required },
  q_5_1a: { required: requiredIf(require51) },
  q_5_1b: { required: requiredIf(require51) },
  q_5_1c: { required: requiredIf(require51) }
};

export { step5Validations, step5 };
